import { createAuthorizationParameters } from '@shared/helpers/AuthorizationParametersHelper'
import { createAuthGuard } from '@auth0/auth0-vue'
import { RouteLocation } from 'vue-router'

export const metaDataAuthGuard: (to: RouteLocation) => Promise<boolean> =
    createAuthGuard({
        redirectLoginOptions: {
            authorizationParams: createAuthorizationParameters({
                source: 'AuthGuard',
            }),
        },
    })
